"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ai_tutor_module_scss_1 = __importDefault(require("./ai-tutor.module.scss"));
var Typography_1 = __importDefault(require("@cdo/apps/componentLibrary/typography/Typography"));
var types_1 = require("@cdo/apps/aiTutor/types");
var INAPPROPRIATE_MESSAGE = 'This chat is inappropriate.';
var TOO_PERSONAL_MESSAGE = 'This chat is too personal.';
var isAssistant = function (role) {
    return role === types_1.Role.ASSISTANT;
};
var isUser = function (role) {
    return role === types_1.Role.USER;
};
var displayUserMessage = function (status, chatMessageText) {
    if (status === types_1.Status.OK || status === types_1.Status.UNKNOWN) {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(ai_tutor_module_scss_1.default.message, ai_tutor_module_scss_1.default.userMessage) }, chatMessageText));
    }
    else if (status === types_1.Status.PROFANITY) {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(ai_tutor_module_scss_1.default.message, ai_tutor_module_scss_1.default.inappropriateMessage) }, INAPPROPRIATE_MESSAGE));
    }
    else if (status === types_1.Status.PERSONAL) {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(ai_tutor_module_scss_1.default.message, ai_tutor_module_scss_1.default.tooPersonalMessage) }, TOO_PERSONAL_MESSAGE));
    }
    else if (status === types_1.Status.ERROR) {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(ai_tutor_module_scss_1.default.message, ai_tutor_module_scss_1.default.tooPersonalMessage) }, 'There was an error getting a response. Please try again.'));
    }
    else {
        return null;
    }
};
var displayAssistantMessage = function (status, chatMessageText) {
    if (status === types_1.Status.OK) {
        return (react_1.default.createElement("div", { id: 'chat-workspace-message-body', className: (0, classnames_1.default)(ai_tutor_module_scss_1.default.message, ai_tutor_module_scss_1.default.assistantMessage) }, chatMessageText));
    }
};
var ChatMessage = function (_a) {
    var message = _a.message;
    return (react_1.default.createElement("div", { id: "chat-message-id-".concat(message.id) },
        isUser(message.role) && (react_1.default.createElement("div", { className: ai_tutor_module_scss_1.default.userMessageContainer }, displayUserMessage(message.status, message.chatMessageText))),
        isAssistant(message.role) && (react_1.default.createElement("div", { className: ai_tutor_module_scss_1.default.assistantMessageContainer },
            react_1.default.createElement(Typography_1.default, { className: ai_tutor_module_scss_1.default.messageHeaderContainer, semanticTag: "h5", visualAppearance: "heading-xs" },
                "(",
                message.role,
                ")"),
            displayAssistantMessage(message.status, message.chatMessageText)))));
};
exports.default = ChatMessage;
